export default __webpack_public_path__ + "static/media/builders.bb936900.svg";